import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react";

const INTERVAL_OPTIONS = [
  { value: 1000, label: "1 second" },
  { value: 1500, label: "1.5 seconds (default)" },
  { value: 2000, label: "2 seconds" },
  { value: 3000, label: "3 seconds" },
  { value: 5000, label: "5 seconds" },
];

export const SettingsPopover = observer(function SettingsPopover({ controller }) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [open]);
  return (
    <div className="cua-settings" ref={wrapperRef}>
      <button
        type="button"
        className="cua-settings-trigger"
        aria-label="Recording settings"
        onClick={() => setOpen((o) => !o)}
      >
        ⚙
      </button>
      {open && (
        <div className="cua-settings-popover">
          <div className="cua-settings-h">Capture screenshot every:</div>
          {INTERVAL_OPTIONS.map((opt) => (
            <label key={opt.value} className="cua-settings-opt">
              <input
                type="radio"
                name="cua-interval"
                checked={controller.intervalMs === opt.value}
                onChange={() => controller.setIntervalMs(opt.value)}
              />
              <span>{opt.label}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
});
